"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactRedux = require("react-redux");
var _footerBottom = _interopRequireDefault(require("./footer-bottom"));
var _footerTop = _interopRequireDefault(require("./footer-top"));
var _footerCountryDropdown = _interopRequireDefault(require("./footer-country-dropdown"));
var _footer = require("./footer.propTypes");
var _footer2 = _interopRequireDefault(require("../styles/footer.css"));
var _DataUtils = new _mmcDataUtilities["default"](),
  isEmptyArray = _DataUtils.isEmptyArray;

// @TODO: This needs to be removed at some point in the future.
// I failed doing so as multiple components rely on window to be defined
// without a proper `typeof window !== 'undefined'` check.
if (typeof window === 'undefined') {
  global.window = {};
}
var initialWindowWidth = window ? window.innerWidth : 768;
var Footer = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(Footer, _React$Component);
  Footer.resourceType = function resourceType() {
    return 'Footer_2_0_0';
  };
  function Footer(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      windowWidth: initialWindowWidth,
      countryModalIsActive: false
    };
    _this.alternateCharSetLanguages = _this.getAlternateCharSetLanguages();
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
    _this.expandCountryModal = _this.expandCountryModal.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCollapseCountryModal = _this.handleCollapseCountryModal.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = Footer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize);
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
    }
  };
  _proto.handleResize = function handleResize() {
    this.setState({
      windowWidth: window.innerWidth
    });
  };
  _proto.handleCollapseCountryModal = function handleCollapseCountryModal() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove(_footer2["default"].preventScroll);
    }
    this.setState({
      countryModalIsActive: false
    });
  };
  _proto.getAlternateCharSetLanguages = function getAlternateCharSetLanguages() {
    var fontPaths = this.props.fontPaths;
    var out = [];
    if (Array.isArray(fontPaths)) {
      fontPaths.forEach(function (font) {
        var lang = font.type.split('-')[1];
        if (lang && lang.length === 2) {
          out.push(lang);
        }
      });
    }
    return out;
  };
  _proto.expandCountryModal = function expandCountryModal() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      var width = window.innerWidth || -1;
      var countryModalIsActive = this.state.countryModalIsActive;
      if (width > 0 && countryModalIsActive === false) {
        document.body.classList.add(_footer2["default"].preventScroll); // eslint-disable-line
      } else {
        document.body.classList.remove(_footer2["default"].preventScroll); // eslint-disable-line
      }
    }
    this.setState({
      countryModalIsActive: true
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      market = _this$props.market,
      theme = _this$props.theme;
    var languages = data.languages;
    var _this$state = this.state,
      countryModalIsActive = _this$state.countryModalIsActive,
      windowWidth = _this$state.windowWidth;
    var isCA = market === 'ca';
    var categoriesArrayCheck = isEmptyArray(data.categories) ? [] : data.categories;
    var sociallinksArrayCheck = isEmptyArray(data.sociallinks) ? [] : data.sociallinks;
    var disclaimerArrayCheck = isEmptyArray(data.disclaimer) ? [] : data.disclaimer;
    var hasMarketLinks = data.globalSiteNavigation && !isEmptyArray(data.globalSiteNavigation.regions);
    return /*#__PURE__*/_react["default"].createElement("footer", {
      className: _footer2["default"].renderWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['container-fluid'], theme.dark)
    }, /*#__PURE__*/_react["default"].createElement(_footerTop["default"], {
      categories: categoriesArrayCheck,
      screenWidth: windowWidth,
      sociallinks: sociallinksArrayCheck,
      locationSelector: isCA ? data.locationSelector : null,
      theme: theme,
      market: market
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(theme['container-fluid'], theme.dark)
    }, /*#__PURE__*/_react["default"].createElement(_footerBottom["default"], {
      links: disclaimerArrayCheck,
      theme: theme,
      copyRight: data.copyRight,
      languages: languages,
      hasMarketLinks: hasMarketLinks,
      changeCountryLabel: hasMarketLinks ? data.globalSiteNavigation.changeCountryLabel : '',
      expandCountryModal: this.expandCountryModal,
      market: market
    })), hasMarketLinks && /*#__PURE__*/_react["default"].createElement(_footerCountryDropdown["default"], {
      theme: theme,
      data: data.globalSiteNavigation,
      isActive: countryModalIsActive,
      handleCollapseCountryModal: this.handleCollapseCountryModal,
      alternateCharSetLanguages: this.alternateCharSetLanguages
    }));
  };
  return Footer;
}(_react["default"].Component);
Footer.displayName = 'Footer';
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(Footer);
exports["default"] = _default;